// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Mt-z","tupacHeader":"Nt-z","tupacHeader2":"Ot-z","tupacMenu":"Pt-z","tupacMenu2":"Qt-z","tupacMain":"Rt-z","tupacMain2":"St-z"};